import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import OpenAI from "openai";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import { Button } from "react-bootstrap";
import { Trash, Check2, X } from "react-bootstrap-icons";
import AdminSidebar from "../../layouts/AdminSidebar";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";
import "./wallOffFame.css";

function RiddleComponent() {
  const [status, setStatus] = useState(false);
  const [clue, setClue] = useState("");
  
  // testing openai
  const client = new OpenAI({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY,
    dangerouslyAllowBrowser: true,
  });
  const openAi = async () => {
    const response = await client.responses.create({
      model: "gpt-4o",
      instructions: "You are a coding assistant that talks like a pirate",
      input: "Are semicolons optional in JavaScript?",
    });
    return response?.output_text;
  };

  useEffect(() => {
    // console.log(openAi());
    // console.log('ve');
  }, []);

  const rebuildQueues = async () => {
    setStatus(true);
    setClue("");
    const resp = await authCall("rebuild-queues", {});
    if (resp?.type === "success") {
      setClue(resp?.payload?.regular[0]?.clue);
      setStatus(false);
    }
  };
  return (
    <>
      <div className="update-machine-page common-table-design py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Riddle Testing</div>
                <div className="details-wrapper py-lg-4">
                  <div className="row">
                    <div className="p-4">
                      <button
                        onClick={rebuildQueues}
                        className="btn btn-custom btn-custom-sm fs-16"
                        disabled={status || false}
                      >
                        {status ? 'Building...' : 'Build Clue Queues'}
                      </button>
                      <p className="mt-2">{clue}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RiddleComponent;
